import { render } from "./ActivitiesListingSettingsHeader.vue?vue&type=template&id=4edcaea4"
import script from "./ActivitiesListingSettingsHeader.vue?vue&type=script&lang=js"
export * from "./ActivitiesListingSettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__